export const SEARCH = 'plp.filter_chip.search';
export const CLEAR_FILTERS = 'plp.filter_chip.clear_filters';
